// src/utils/heightPersistence.ts (Final & Corrected)
const HEIGHT_KEY_PREFIX = "cueboard.tag.height.";

function heightKey(packetId: string, noteId: string): string {
  return `${HEIGHT_KEY_PREFIX}${packetId}.${noteId}`;
}

export function readSavedHeight(packetId: string | null, noteId: string): number | null {
  if (!packetId) return null;
  try {
    const v = localStorage.getItem(heightKey(packetId, noteId));
    const n = v ? parseInt(v, 10) : NaN;
    return Number.isFinite(n) && n > 0 ? n : null;
  } catch {
    return null;
  }
}

export function saveHeight(packetId: string | null, noteId: string, px: number) {
  if (!packetId) return;
  try {
    if (Number.isFinite(px) && px > 0) {
      localStorage.setItem(heightKey(packetId, noteId), String(Math.round(px)));
    }
  } catch {}
}

export function autosize(el: HTMLTextAreaElement | null): number {
  if (!el) return 0;
  el.style.overflow = "hidden";
  el.style.height = "auto";
  const nextH = Math.max(el.scrollHeight, 48);
  el.style.height = nextH + "px";
  return nextH;
}

export function autosizeAndPersist(packetId: string | null, noteId: string, el: HTMLTextAreaElement | null) {
  const h = autosize(el);
  saveHeight(packetId, noteId, h);
}

export function applySavedOrAutosize(packetId: string | null, noteId: string, el: HTMLTextAreaElement | null) {
  if (!el) return;
  const saved = readSavedHeight(packetId, noteId);
  if (saved) {
    el.style.overflow = "hidden";
    el.style.height = saved + "px";
  } else {
    if (!packetId) {
      // Visual autosize only until we know the packet id
      autosize(el);
    } else {
      autosizeAndPersist(packetId, noteId, el);
    }
  }
}